export const connecting = 'connecting';
export const reconnecting = 'reconnecting';
export const connected = 'connected';
export const disconnected = 'disconnected';
export const timeout = 'timeout';